import { render, staticRenderFns } from "./titleTips.vue?vue&type=template&id=785a34dd&scoped=true"
import script from "./titleTips.vue?vue&type=script&lang=js"
export * from "./titleTips.vue?vue&type=script&lang=js"
import style0 from "./titleTips.vue?vue&type=style&index=0&id=785a34dd&prod&lang=scss&scoped=true"
import style1 from "./titleTips.vue?vue&type=style&index=1&id=785a34dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a34dd",
  null
  
)

export default component.exports